// Mock data for Tasarı Bilgisayar website

export const translations = {
  tr: {
    nav: {
      home: 'Ana Sayfa',
      services: 'Hizmetler',
      partners: 'İş Ortakları',
      references: 'Referanslar',
      contact: 'İletişim'
    },
    hero: {
      title: 'Tasarı Bilgisayar',
      subtitle: 'Danışmanlık ve Network Hizmetleri',
      description: 'Bilgisayar donanımı, network sistemleri ve güvenlik çözümlerinde profesyonel hizmet',
      cta: 'İletişime Geçin'
    },
    services: {
      title: 'Hizmetlerimiz',
      subtitle: 'Teknoloji ihtiyaçlarınız için kapsamlı çözümler',
      items: [
        {
          title: 'Network Sistemleri',
          description: 'Kurumsal network altyapınızı profesyonel ekibimizle planlayıp hayata geçiriyoruz'
        },
        {
          title: 'Kablolama & Projelendirme',
          description: 'Strukturel kablolama ve network projelendirme hizmetleri'
        },
        {
          title: 'Güvenlik Sistemleri',
          description: 'Modern güvenlik sistemleri ile işletmenizi koruyoruz'
        },
        {
          title: 'CCTV Sistemleri',
          description: 'IP ve analog kamera sistemleri kurulum ve bakım hizmetleri'
        },
        {
          title: 'PC Donanım Satış & Servis',
          description: 'Bilgisayar donanımları satış, kurulum ve teknik servis'
        },
        {
          title: 'Donanım Danışmanlığı',
          description: 'İhtiyacınıza özel donanım seçimi ve sistem tasarımı'
        }
      ]
    },
    partners: {
      title: 'İş Ortaklarımız',
      subtitle: 'Güvenilir markalarla çalışıyoruz'
    },
    contact: {
      title: 'İletişim',
      subtitle: 'Bizimle iletişime geçin',
      form: {
        name: 'Ad Soyad',
        email: 'E-posta',
        phone: 'Telefon',
        message: 'Mesajınız',
        submit: 'Gönder',
        success: 'Mesajınız başarıyla gönderildi!',
        error: 'Bir hata oluştu. Lütfen tekrar deneyin.'
      },
      info: {
        address: 'Hürriyet Mah Eski Edirne Asfaltı No:176/B 500 Evler / Gaziosmanpaşa / İstanbul',
        phone: '0541 230 23 30',
        email: 'osman@tasaribilgisayar.com'
      }
    },
    references: {
      title: 'Referanslarımız',
      subtitle: 'Güvenini kazandığımız markalar',
      description: 'Çalışmaktan gurur duyduğumuz müşterilerimiz'
    },
    footer: {
      rights: 'Tüm hakları saklıdır',
      description: 'Bilgisayar Danışmanlık ve Network Hizmetleri'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      partners: 'Partners',
      references: 'References',
      contact: 'Contact'
    },
    hero: {
      title: 'Tasarı Computer',
      subtitle: 'Consulting and Network Services',
      description: 'Professional services in computer hardware, network systems and security solutions',
      cta: 'Get In Touch'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive solutions for your technology needs',
      items: [
        {
          title: 'Network Systems',
          description: 'We plan and implement your corporate network infrastructure with our professional team'
        },
        {
          title: 'Cabling & Project Design',
          description: 'Structural cabling and network project design services'
        },
        {
          title: 'Security Systems',
          description: 'Protecting your business with modern security systems'
        },
        {
          title: 'CCTV Systems',
          description: 'IP and analog camera systems installation and maintenance services'
        },
        {
          title: 'PC Hardware Sales & Service',
          description: 'Computer hardware sales, installation and technical service'
        },
        {
          title: 'Hardware Consulting',
          description: 'Custom hardware selection and system design'
        }
      ]
    },
    partners: {
      title: 'Our Partners',
      subtitle: 'Working with trusted brands'
    },
    contact: {
      title: 'Contact',
      subtitle: 'Get in touch with us',
      form: {
        name: 'Full Name',
        email: 'Email',
        phone: 'Phone',
        message: 'Your Message',
        submit: 'Send',
        success: 'Your message has been sent successfully!',
        error: 'An error occurred. Please try again.'
      },
      info: {
        address: 'Hürriyet Mah Eski Edirne Asfaltı No:176/B 500 Evler / Gaziosmanpaşa / Istanbul',
        phone: '0541 230 23 30',
        email: 'osman@tasaribilgisayar.com'
      }
    },
    references: {
      title: 'Our References',
      subtitle: 'Brands that trust us',
      description: 'Clients we are proud to work with'
    },
    footer: {
      rights: 'All rights reserved',
      description: 'Computer Consulting and Network Services'
    }
  }
};

export const partnerLogos = [
  { name: 'Hikvision', url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Hikvision_logo.svg/2560px-Hikvision_logo.svg.png' },
  { name: 'Sophos', url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Sophos_logo.svg/2560px-Sophos_logo.svg.png' },
  { name: 'HP', url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/HP_logo_2012.svg/2048px-HP_logo_2012.svg.png' },
  { name: 'Dell', url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Dell_Logo.svg/2048px-Dell_Logo.svg.png' },
  { name: 'Cisco', url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Cisco_logo_blue_2016.svg/2560px-Cisco_logo_blue_2016.svg.png' },
  { name: 'Lenovo', url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Lenovo_logo_2015.svg/2560px-Lenovo_logo_2015.svg.png' },
  { name: 'TP-Link', url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/TP-Link_logo.svg/2560px-TP-Link_logo.svg.png' },
  { name: 'Dahua', url: 'https://upload.wikimedia.org/wikipedia/commons/d/dd/Dahua_Technology_logo.png' }
];

export const referenceLogos = [
  { name: 'Hugo Boss', url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0b/Hugo_Boss_logo.svg/2560px-Hugo_Boss_logo.svg.png' },
  { name: 'Nike', url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Logo_NIKE.svg/2560px-Logo_NIKE.svg.png' },
  { name: 'Aster Tekstil', url: 'https://via.placeholder.com/200x80/f0f0f0/333333?text=Aster+Tekstil' },
  { name: 'Artesa Kumaş', url: 'https://via.placeholder.com/200x80/f0f0f0/333333?text=Artesa+Kumaş' },
  { name: 'Yenidoğu Okulları', url: 'https://via.placeholder.com/200x80/f0f0f0/333333?text=Yenidoğu+Okulları' },
  { name: 'Dürümcü Baba', url: 'https://via.placeholder.com/200x80/f0f0f0/333333?text=Dürümcü+Baba' },
  { name: 'Binmet Metal', url: 'https://via.placeholder.com/200x80/f0f0f0/333333?text=Binmet+Metal' },
  { name: 'Cevahir Yapı', url: 'https://via.placeholder.com/200x80/f0f0f0/333333?text=Cevahir+Yapı' },
  { name: 'Eber Mimarlık', url: 'https://via.placeholder.com/200x80/f0f0f0/333333?text=Eber+Mimarlık' },
  { name: 'Kent Makina', url: 'https://via.placeholder.com/200x80/f0f0f0/333333?text=Kent+Makina' }
];
